import React from "react";

import TaktileIcon from "src/assets/Taktile.svg?react";
import { useRemoteIcon } from "src/connections/queries";
import { NodeIcon, NodeIconSize } from "src/design-system/NodeIcon";
import { DashboardPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

const taktileMediaKey = "taktile-icon";

type CustomIconProps = {
  mediaKey: string | null;
  size: NodeIconSize;
};

export const CustomIcon: React.FC<CustomIconProps> = ({ mediaKey, size }) => {
  const isTaktileIcon = mediaKey === taktileMediaKey;
  const { wsId } = useParamsDecode<DashboardPageParams>();
  const {
    data: iconSrc,
    isError,
    isLoading,
  } = useRemoteIcon(mediaKey, wsId, {
    enabled: !isTaktileIcon,
  });

  // Special case: show taktile icon directly
  if (isTaktileIcon) {
    return <NodeIcon svg={TaktileIcon} size={size} />;
  }

  if (isLoading || !iconSrc || isError) {
    return <div />;
  }

  return (
    <NodeIcon
      alt="Custom Icon"
      dataLoc="custom-icon"
      imageSrc={iconSrc}
      size={size}
    />
  );
};
